import template from './customers.html';
import controller from './customers.controller';

let customersComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default customersComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/customers/customers.component.js